// extracted by extract-css-chunks-webpack-plugin
module.exports = {"body":"QcRoVcei783jqu54wwgt","container":"Bg_pFyEopQtTkvzGSjVU","button":"kMJVxauuPrAcYRsKDDwR","header":"WehKWlDND2C_qjpdHaSR","size":"jvQmWofG3O6aT8iYovul"};